import styled from 'styled-components';

const activeModifier = (props) => props.active && ({
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  top: 0,
  zIndex: 1000,
  background: '#fff',
  padding: '14px',
});

export default styled.div`
  padding: 0;
  ${activeModifier}
`;

